export default "__VITE_PUBLIC_ASSET__fed9a74f__"